import { System } from "../../Models/Customer/System"
import { OpportunityTitle } from "../../Models/Customer/OpportunityTitle"
import { InverterTypeModel } from "../../Models/SystemDetails/InverterTypeModel";
import { WeatherStation } from "../../Models/WeatherStation/WeatherStation"
import { IncentiveProgram } from "../CostCalculation/IncentiveProgram";
import { PaymentTerms } from "./PaymentTerms";

export interface ISolarAdditionalCustomerDetailsResponse {
  sellingAgent: string;
  abpAccountNumber: number;
  estimatedAnnualProd: number;
  yield: number;
  systemSize: number;
  contractStartDate: Date;
  contractTermLength: number;
  system: System;
  opportunityTitle: OpportunityTitle;
  trustName: string;
  utility: string;
  /** @deprecated SOL-5988 */
  region: string;
  inverterType: InverterTypeModel;
  customerNameFromCreditCheck: string;
  productType: string;
  isAutoPay: boolean;
  isPaperInvoice: boolean;
  customerType: string;
  weatherStation: WeatherStation;
  incentiveProgram: IncentiveProgram;
  paymentTerms: PaymentTerms;
  isPrepaid: boolean;
}

export class SolarAdditionalCustomerDetailsResponse
  implements ISolarAdditionalCustomerDetailsResponse {
  public sellingAgent: string;
  public abpAccountNumber: number;
  public estimatedAnnualProd: number;
  public yield: number;
  public systemSize: number;
  public contractStartDate: Date;
  public contractTermLength: number;
  public system: System;
  public opportunityTitle: OpportunityTitle;
  public trustName: string;
  public utility: string;
  public region: string;
  public inverterType: InverterTypeModel;
  public customerNameFromCreditCheck: string;
  public productType: string;
  public isAutoPay: boolean;
  public isPaperInvoice: boolean;
  public customerType: string;
  public weatherStation: WeatherStation;
  public incentiveProgram: IncentiveProgram;
  public paymentTerms: PaymentTerms;
  public isPrepaid: boolean;
}
